import {
    BackButton,
    BackButtonIconType,
    BodyLargeRegular,
    InfoButton,
    SafeAreaView,
    XStack,
} from 'smoothie';

const HEADER_SIDE_WIDTH = 50;

export const HolisticNavHeader = ({
    title,
    isScrolled,
    height,
    onPressInfoIcon,
    onPressBack,
}: {
    title?: string;
    isScrolled: boolean;
    height: number;
    onPressInfoIcon?: () => void;
    onPressBack?: () => void;
}) => {
    return (
        <SafeAreaView
            noBottomPadding={true}
            edges={['top', 'left', 'right']}
            style={{ width: '100%', height }}
        >
            <XStack
                backgroundColor={isScrolled ? '$white' : '$gray100'}
                width="100%"
                paddingTop={8}
                maxWidth={700}
                marginVertical="auto"
                alignSelf="center"
                alignItems="center"
                justifyContent="space-between"
                paddingHorizontal={16}
                $sm={{ paddingHorizontal: 0 }}
            >
                <XStack width={HEADER_SIDE_WIDTH}>
                    <BackButton
                        background="transparent"
                        iconType={BackButtonIconType.ARROW_LEFT}
                        {...(onPressBack != null
                            ? { customBackFn: onPressBack }
                            : {})}
                    />
                </XStack>
                {title !== undefined && (
                    <BodyLargeRegular>{title}</BodyLargeRegular>
                )}
                <XStack width={HEADER_SIDE_WIDTH} justifyContent="flex-end">
                    {onPressInfoIcon !== undefined && (
                        <InfoButton onPress={onPressInfoIcon} />
                    )}
                </XStack>
            </XStack>
        </SafeAreaView>
    );
};
